const VirtualCardIcon = ({ className }) => {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-primary-600"
      >
        <rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect>
        <line x1="1" y1="12" x2="19" y2="12"></line>
        <path d="M19 9a3 3 0 0 1 0 6"></path>
        <path d="M22 7a6 6 0 0 1 0 10"></path>
      </svg>
    </div>
  );
};

export default VirtualCardIcon;
